/**
 * FRANGIPANI TABS  ·  fp-tabs.js
 * Transforms Horizon's native accordion into a horizontal tab bar.
 *
 * Auto-applies:  .product-details .accordion  (product page panels)
 * Manual apply:  add  data-fp-tabs  attribute to any .accordion block
 */
(function () {
  'use strict';

  class FPTabs {
    constructor(accordion) {
      this.accordion = accordion;
      this.rows = Array.from(
        accordion.querySelectorAll(':scope > accordion-custom')
      );
      if (this.rows.length < 2) return;
      this.details = this.rows.map(r => r.querySelector('details'));
      this.init();
    }

    init() {
      const bar = document.createElement('nav');
      bar.className = 'fp-tab-bar';
      bar.setAttribute('role', 'tablist');

      this.rows.forEach((row, i) => {
        const summary = row.querySelector('summary');
        const label   = this.getLabel(summary);
        const isActive = !!this.details[i]?.open || (i === 0 && !this.details.some(d => d?.open));

        const btn = document.createElement('button');
        btn.className = 'fp-tab' + (isActive ? ' fp-tab--active' : '');
        btn.textContent = label;
        btn.type  = 'button';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', String(isActive));

        btn.addEventListener('click', () => this.activate(i));
        bar.appendChild(btn);
      });

      this.accordion.prepend(bar);
      this.accordion.classList.add('fp-tabs--ready');
    }

    getLabel(summary) {
      if (!summary) return '';
      let text = '';
      summary.childNodes.forEach(node => {
        if (node.nodeType === 3) text += node.textContent;
      });
      text = text.trim();
      if (!text) {
        const clone = summary.cloneNode(true);
        clone.querySelectorAll('.svg-wrapper, svg').forEach(n => n.remove());
        text = clone.textContent.trim();
      }
      return text;
    }

    activate(activeIndex) {
      this.details.forEach((detail, i) => {
        if (!detail) return;
        const customEl = this.rows[i];
        if (i === activeIndex) {
          detail.open = true;
          if (customEl) customEl.setAttribute('open', '');
        } else {
          detail.open = false;
          if (customEl) customEl.removeAttribute('open');
        }
      });

      this.accordion.querySelectorAll('.fp-tab').forEach((btn, i) => {
        const active = i === activeIndex;
        btn.classList.toggle('fp-tab--active', active);
        btn.setAttribute('aria-selected', String(active));
      });
    }
  }

  function init() {
    document.querySelectorAll(
      '.product-details .accordion:not(.fp-tabs--ready)'
    ).forEach(el => new FPTabs(el));

    document.querySelectorAll(
      '.accordion[data-fp-tabs]:not(.fp-tabs--ready)'
    ).forEach(el => new FPTabs(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
